import "../../../../assets/presentation/components/layout/top-bar/top-bar-bm2QOEfv.css";
import { Button, ButtonPriority } from "../../controls/button/button2.js";
import { usePaths } from "../../../hooks/use-paths.js";
import { Header, Navigation } from "../layout.js";
import { LogoType } from "../../../../domain/logo/logo.js";
import { Logo } from "../../utils/logo.js";
/* empty css        */
import { useNavigate } from "react-router";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/layout/top-bar/top-bar.tsx
var TopBar = () => {
	const paths = usePaths();
	const navigate = useNavigate();
	return /* @__PURE__ */ jsx(Header, {
		className: "top-bar",
		children: /* @__PURE__ */ jsx(Navigation, { children: /* @__PURE__ */ jsx("ul", { children: /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Button, {
			priority: ButtonPriority.TERTIARY,
			onClick: () => {
				navigate(paths?.home?.HOME);
			},
			children: /* @__PURE__ */ jsx(Logo, { type: LogoType.VanaCardBlue })
		}) }) }) })
	});
};
//#endregion
export { TopBar };

//# sourceMappingURL=top-bar2.js.map